import { useState } from "react";
import { useLoad } from "../lib/api.jsx";
import { Wait, Tbl, Pager, Filters, csv, clip } from "../lib/ui.jsx";

export default function Activity() {
  const [f, setF] = useState({ search: "", section: "", from: "", to: "", page: 1 });
  const [d] = useLoad("activity", f);

  return (
    <>
      <h1>Activity</h1>
      <Filters f={f} setF={setF}>
        <select value={f.section} onChange={(e) => setF({ ...f, section: e.target.value, page: 1 })}>
          <option value="">All sections</option>
          {d?.sections?.map((s) => <option key={s}>{s}</option>)}
        </select>
        <button className="btn g" onClick={() => d?.rows && csv("activity", d.rows)}>Export page</button>
      </Filters>
      <Wait d={d}>
        {d && !d.error && (
          <>
            <Tbl rows={d.rows} empty="No activity matches." cols={[
              ["When", (r) => r.time_stamp], ["User", (r) => r.Name || r.sopnoid], ["Section", (r) => r.section],
              ["Type", (r) => r.act_type], ["Action", (r) => clip(r.action, 80)], ["Reference", (r) => r.refer || "-"],
            ]} />
            <Pager f={f} setF={setF} d={d} />
          </>
        )}
      </Wait>
    </>
  );
}
